import {
  Box,
  Button,
  Heading,
  useToast,
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";
import { RepeatIcon } from "@chakra-ui/icons";
import * as React from "react";
import { api } from "../../config";
import axios from "axios";

const Settings: React.FC = () => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef<HTMLButtonElement>(null);

  const handleConfirm = async () => {
    try {
      const response = await axios.post(
        `${api}/announcements/refresh-settings`,
        {},
        {
          withCredentials: true,
        },
      );

      toast({
        title: response.data.message || "Settings refreshed.",
        status: "success",
        duration: 2000,
        isClosable: true,
        position: "bottom-right",
      });
    } catch (error) {
      toast({
        title: "Failed to refresh settings.",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "bottom-right",
      });
    } finally {
      onClose();
    }
  };

  return (
    <Box p={5} boxShadow="md" bg="white" borderRadius="md">
      <Heading size="md" mb={4}>
        Settings
      </Heading>

      <Button
        leftIcon={<RepeatIcon />}
        colorScheme="blue"
        onClick={onOpen}
        size="sm"
      >
        Reload System
      </Button>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Action
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to reload the system?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="blue" onClick={handleConfirm} ml={3}>
                Confirm
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default Settings;
